import styled from '@emotion/styled';
import Box from '@mui/material/Box';

export const DownloadArea = styled(Box)`
    display: flex;
    min-height: 100px;
    justify-content: center;
    align-items: center;
    position: relative;

    &[drop-active]:before {
        border-width: 2px;
    }

    &:before {
        content: ' ';
        border: 1px dashed cornflowerblue;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }
`;